module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-dagger-stub-1.3c157ecf.svg";